export default __webpack_public_path__ + "static/char-s-17-chs-6b23e6d0b321bac79c6bb88752c4cd20.png";